import { MenuService } from 'usermanagement-boothelp/src/app/core/services/menu.service';
import { Component, OnInit, Inject, Pipe } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { IMenu, Menu, MenuSearch } from "usermanagement-boothelp/src/app/shared/models/menu.model";
import { DigitalMailboxService } from '@app/core/services/digital-mailbox.service';
import { AppConstant } from '@app/configs/app.constant';
import { AlertService } from '@app/core/services/alert.service';
import { ceil, floor } from 'lodash';
import { Subject, Subscription } from 'rxjs';
import { FetchDigitalMailboxService } from "@app/core/services/fetch-digital-mailbox.service";
import { TranslateService } from "@ngx-translate/core";
import { APP_CONFIG, AppConfig } from '@app/app-config.module';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ClientsSessionService } from '@shared/services/client-session.service';
import { modulesConfig } from '@app/configs/module.config';

import { ProjectConfigService } from '@app/core/services/project-config.service'; 
 
import {
  IModuleConfig,
  IExternalLinkConfig,
  ModuleType,
  ModuleCode
} from '@app/core/models/project-config.model';   
import { ManageService } from '@app/core/services/manage-service.service';
import { CheckCompanyCanUserServiceRequest, ResultCheckCompanyCanUserService, ServiceInfo } from '@app/core/models/manage-service.model'; 
import { UserManagementService } from '@app/core/services/user-management.service'; 
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import Swal from "sweetalert2";
import { mdConfig } from 'usermanagement-boothelp/src/app/configs/app-package.config';
import { UserChangePwdComponent } from '@app/modules/user-change-pwds/user-change-pwd/user-change-pwd.component'
import { LogoutAdfsComponent } from '@app/modules/auth/logout-adfs/logout-adfs.component';
import * as _ from 'lodash';
import { AddressBookService } from '@app/core/services/address-book.service';
import { StorageUsageInfo } from '@app/core/models/storage-usage.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { SigningHubTranslateLanguage, SigningHubUser } from '@app/core/models/signing-hub-user.model';
import { SigningHubService } from '@app/core/services/signing-hub.service';

declare var beconsent:any;
declare var dsrm:any;

@Component({
  selector: 'app-dashboard-sidebar',
  templateUrl: './dashboard-sidebar.component.html',
  styleUrls: ['./dashboard-sidebar.component.css']
})
export class DashboardSidebarComponent implements OnInit {
  public modulesConfig = modulesConfig;
  public externalLinkConfig: IExternalLinkConfig;
  private serviceInfo: ServiceInfo[];
  public imenus: IMenu[] = [];
  public isLoading: boolean = false;  
  public storageLoading: boolean = false;
  public storageSize: number = 0;
  public signingHubTranslateLanguage : SigningHubTranslateLanguage = new SigningHubTranslateLanguage();
  max: number = 100;
  value: number = 80;
  countInboxUnread: number = 0;
  countDrafts: number = 0;
  usagePercent: number = 0;
  lang: string;
  public profileImage: any = null; 

  public showMenu: string = "";
  public currentUser: any;
  public subscription!: Subscription;
  public isDesktop: boolean = false;
  public storageUsageInfo: StorageUsageInfo;
  public storageUsagePercent: number;
  public storageUsageType: string;
  public permissionManageDocument: string = 'MANAGE_DOCUMENT';
  public permission: any;
  public storageDocument: boolean = true;
  public spinnerName = 'dashboard-spinner';

  constructor(
    @Inject(APP_CONFIG) private config: AppConfig,
    private router: Router,
    private digitalMailboxService: DigitalMailboxService,
    private fetchDigitalMailboxService: FetchDigitalMailboxService,
    private addressBookService: AddressBookService,
    private alertService: AlertService, 
    public translate: TranslateService,
    private deviceService: DeviceDetectorService,
    private projectConfigService: ProjectConfigService,
    private manageService: ManageService,
    private clientService: ClientsSessionService, 
    private userManagementService: UserManagementService, 
    private modalService: BsModalService,
    private menuService: MenuService,
    private spinner: NgxSpinnerService,
    private signingHubService : SigningHubService
  ) {
    this.clientService.init();
    if(this.deviceService.getDeviceInfo().deviceType == 'desktop'){
      this.isDesktop = true;
    }
    console.log("modulesConfig : ",modulesConfig)
  }

  ngOnInit() {
    this.permission = this.clientService.getPermissions();

    this.lang = sessionStorage.getItem('lang') ? sessionStorage.getItem('lang') : this.config.defaultLanguage;
    this.translate.use(this.lang);
    this.getCurrentLoggedon();  
    let mailboxUser = JSON.parse(sessionStorage.getItem("mailboxUser") || '{}');
    this.profileImage = mailboxUser['profilePicture'];  
    const currentUser = JSON.parse(
      sessionStorage.getItem("currentUser") || "{}"
    );
    const gid = currentUser.gid;
    this.getMenu(gid);
    this.fetchExternalLinkConfig();
    this.getService();
    this.getStorage();
    
    this.subscription = this.fetchDigitalMailboxService.fetch().subscribe((data: any) => { 
      if(data){
        this.getStorage();
      }
    });
  }
 
  changeLanguage(lang) {
    this.translate.use(lang);
    sessionStorage.setItem("lang", lang)
    this.lang = lang;   

    // this.signingHubTranslateLanguage.language = lang.toLowerCase() === "en" ? "en-EN":"th-TH";
    // this.signingHubService.translateLanguage(this.signingHubTranslateLanguage,this.clientService.getCpid()).subscribe({
    //   next: (v) => {
    //       console.log(v);
    //   },
    //   error: (e) => {
    //     console.error(e);
    //   },
    // });
  }
 
  addExpandClass(element: any) {
    console.log("element : ", element)
    this.showMenu =
      element === this.showMenu
        ? (this.showMenu = "0")
        : (this.showMenu = element);
  }

  menuChange(menu: string, url: string, isInit: boolean = false) {
    console.log("url: ", url)
    if (!isInit) {
      console.log("if")
      this.router
        .navigateByUrl('/reload', { skipLocationChange: true })
        .then(() => {
          this.router.navigate([url]);
          //// mobile & ipad auto close sidebar
          if(!this.isDesktop){
            this.toggleSidebar()
          }
          
        })
    } else {
      console.log("else")
      this.router.navigate([url]);
      //// mobile & ipad auto close sidebar
      if(!this.isDesktop){
        this.toggleSidebar()
      }
    }
  }

  getCurrentLoggedon() {
    this.currentUser = JSON.parse(
      sessionStorage.getItem("currentUser") || "{}"
    );
  }

  getStorage() {
    this.storageLoading = true;
    this.addressBookService.getDocumentManagementStorage(this.clientService.getCpid())
      .subscribe({
        next: (v) => {
          this.storageUsageInfo = v; 
          this.storageSize = this.storageUsageInfo.usageInBytes
          this.getCountMessage();          
        },
        error: (e) => {
          this.storageSize = 0;
          this.getCountMessage(); 
          console.log(e.message)
        }
      })
  }

  calculateStorageUsage() {
    if(this.storageUsageInfo) this.storageUsagePercent = floor(this.storageSize / this.storageUsageInfo.bucketSizeInBytes * 100);
    else this.storageUsagePercent = floor(this.value / 524288000 * 100);
    if (this.storageUsagePercent < 25) {
      this.storageUsageType = 'success';
    } else if (this.storageUsagePercent < 50) {
      this.storageUsageType = 'info';
    } else if (this.storageUsagePercent < 75) {
      this.storageUsageType = 'warning';
    } else {
      this.storageUsageType = 'danger';
    }
  }

  oncheckPermission(permission: string) { 
    if(this.permission.includes(permission)){        
      return true
    }else{
      return false
    }
  }

  toggleSidebar() {
    const dom: any = document.querySelector("body");
    dom.classList.toggle("menuleft-hide");
  }
  // new

  fetchExternalLinkConfig() {
    this.projectConfigService.externalLinkConfig().subscribe({
      next: (v) => {
        if (v.code == AppConstant.HTTP_STATUS_CODE_SUCCESS) {
          sessionStorage.setItem("externalLink",JSON.stringify(v.data));
          this.externalLinkConfig = v.data;
        } else {
          console.log(v.message);
        }
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  getService() {
    this.manageService.listService().subscribe({next: (v) => {
      this.serviceInfo = v.data.result;
    }, error:(e)=>{

    }})
  }

  onInternalModule(routePath: string) {  
    if(this.router.url.includes(routePath)) this.router.navigate([routePath]).then(()=> window.location.reload())
    else this.router.navigate([routePath])
  }

  onExternalModule(urlPath: string, useApiConfigValue: boolean) { 
    if (useApiConfigValue) {
      urlPath = this.externalLinkConfig[urlPath];  
    }
      window.open(urlPath, '_blank'); 
  }

  onInternalModuleForSafari(urlPath: string, useApiConfigValue: boolean){
    if (useApiConfigValue) {
      urlPath = this.externalLinkConfig[urlPath];  
    }
      window.open(urlPath, '_self');  
  }

  async onAction(module: IModuleConfig) {
    console.log("module: ",module)
    console.log("serviceCode: ",module.serviceCode)
    this.spinner.show(this.spinnerName);
    if(module.serviceCode){
      const canUserService = await this.checkIdentity(module.serviceCode);      
      if(!canUserService.can) {
        if(canUserService.selfService){
          this.alertService.warningKYC(this.translate.instant('KYC.Please KYC on mobile'),this.translate.instant('KYC.Warning KYC'))
        } else { 
          this.alertService.confirm(this.translate.instant('KYC.ServiceRequireAlert', {moduleName : module.name}),this.translate.instant('KYC.Please KYC'))
          .then((confirm)=> {                    
            if(confirm.value){
              this.router.navigate(["/mainmenu/kyc"], { state: {identity: canUserService.requireIdentityTypeIdList}});
            }
          });
        }
        return ;
      } else {
        await this.getListPermission();        
      }
    }

    if(module.serviceCode == ModuleCode.PrintAndPost){
      //// check document management ด้วย
      console.log("check can use document management for print and post") 
      const canUserService = await this.checkIdentity(ModuleCode.DocumentManagement);      
      if(!canUserService.can) {
        if(canUserService.selfService){
          this.alertService.warningKYC(this.translate.instant('KYC.Please KYC on mobile'),this.translate.instant('KYC.Warning KYC'))
        } else { 
          let moduleFilter = this.modulesConfig.filter((service) => service.serviceCode == ModuleCode.DocumentManagement); 
          this.alertService.confirm(this.translate.instant('KYC.ServiceRequireAlert', {moduleName : moduleFilter[0].name}),this.translate.instant('KYC.Please KYC'))
          .then((confirm)=> {                    
            if(confirm.value){
              this.router.navigate(["/mainmenu/kyc"], { state: {identity: canUserService.requireIdentityTypeIdList}});
            }
          });
        }
        return ;
      } else {
        await this.getListPermission();        
      }      
    }
    
    this.spinner.hide(this.spinnerName);

    switch (module.type) {
      case ModuleType.Internal:
        this.onInternalModule(module.urlPath);
        break;
      case ModuleType.External:
        if(module.serviceCode == ModuleCode.DocumentManagement) this.onInternalModuleForSafari(module.urlPath, module.useApiConfigValue);
        // if(this.deviceService.getDeviceInfo().browser == 'Safari' && this.deviceService.getDeviceInfo().deviceType !== 'desktop') this.onInternalModuleForSafari(module.urlPath, module.useApiConfigValue);
         
        else { 
          if(module.code == ModuleCode.Helpdesk){
            if(this.permission.includes('SYS_ADMIN')){
              this.onExternalModule(module.urlPath, module.useApiConfigValue);
            }else{
              this.onExternalModule(`${module.urlPath}${this.config.helpdeskQueryParams}`, module.useApiConfigValue);
            }
            //// check permission sys_admin 
          }else{
            this.onExternalModule(module.urlPath, module.useApiConfigValue); 
          }
        }
        break;
      default:
        throw new Error(this.translate.instant('KYC.Module not implemented.'));
    } 
  } 

  async onActionSubMenu(module: IModuleConfig, url : string){ 
    if(module.serviceCode){
      const canUserService = await this.checkIdentity(module.serviceCode);      
      if(!canUserService.can) {
        if(canUserService.selfService){
          this.alertService.warningKYC(this.translate.instant('KYC.Please KYC on mobile'),this.translate.instant('KYC.Warning KYC'))
        } else { 
          this.alertService.confirm(this.translate.instant('KYC.ServiceRequireAlert', {moduleName : module.name}),this.translate.instant('KYC.Please KYC'))
          .then((confirm)=> {                    
            if(confirm.value){
              this.router.navigate(["/mainmenu/kyc"], { state: {identity: canUserService.requireIdentityTypeIdList}});
            }
          });
        }
        return ;
      } else {
        await this.getListPermission();        
      }
    }
    this.router.navigate([url])
  }

  checkIdentity(serviceCode: string) : Promise<ResultCheckCompanyCanUserService>{
    return new Promise((resolve) => {

      let serviceFileter = this.serviceInfo.filter((service) => service.serviceCode == serviceCode);

      if(serviceFileter.length == 0) return this.alertService.error(this.translate.instant("KYC.Not found service"));

      const serviceID = serviceFileter[0].serviceId;

      let checkCompanyCanUserServiceRequest: CheckCompanyCanUserServiceRequest = {cpid: this.clientService.getCpid(), serviceId: serviceID};

      this.manageService.checkCompanyCanUseService(checkCompanyCanUserServiceRequest).subscribe({next:(v)=> {
        if(v.code === AppConstant.HTTP_STATUS_CODE_SUCCESS){
          resolve(v.data);
        }
      }, error:(e)=> {
          resolve(new ResultCheckCompanyCanUserService({can: false,requireIdentityTypeIdList: []}));
      }});
    });
    
      
  }

  getListPermission() : Promise<boolean>{
    return new Promise((resolve) => {            
      this.userManagementService.getListPermission().subscribe({next:(v)=> {
        if(v.code === AppConstant.HTTP_STATUS_CODE_SUCCESS){
          let currentUser = JSON.parse(
            sessionStorage.getItem("currentUser") || "{}"
          );          
          currentUser['permissions'] = v.data
          sessionStorage.setItem("currentUser",JSON.stringify(currentUser));

          resolve(true);
        }
      }, error:(e)=> {
          resolve(true);
      }});
    });      
  }

  deleteAllCookies() {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }

  logout() {

    Swal.fire({
      text: this.translate.instant("WARNING.Are you sure you want to logout") + " ?",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      confirmButtonText: this.translate.instant("Yes"),
      cancelButtonText: this.translate.instant("No"),
    }).then((result) => {
      if (result.value) {        
                
        this.deleteAllCookies();    
        
        this.modalService.show(LogoutAdfsComponent, {
          ...mdConfig,
          class: "modal-lg",
        });        
      }
    });
  }

  profile() {
    this.router.navigate(["/mainmenu/profile"]);
  }

  otp() {
    this.router.navigate(["/mainmenu/otp"]);
  }


  changePassword() {
    const initialState = {
      title: "Change Password",
    };
    this.modalService.show(UserChangePwdComponent, {
      initialState,
      ...mdConfig,
      class: "modal-lg",
    });
  }

  async consent() {     
    await beconsent.init({ uid: `${this.currentUser.uid}`, name: `${this.currentUser.firstname} ${this.currentUser.lastname}`})
    beconsent.show();
  }

  async dsrmClick() {
    console.log('dsrmClick');
    
    let data = {
      uid: this.currentUser.uid,
      identity: {
        firstName: this.currentUser.firstname,
        lastName: this.currentUser.lastname,
        email: this.currentUser.email,
        country: "TH",
      },
    };
    dsrm.init(data);
  }

  requestKYCCode(){
    this.router.navigate(["/mainmenu/kyc"]);
  }

  requestKYCHistory(){
    this.router.navigate(["/mainmenu/kyc/history"]);
  }

  
  getMenu(gid: string) {
    this.isLoading = true;
    this.menuService.getMenuList(1, 9999, { gid: gid } as MenuSearch).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.imenus = this.groupMenu((res && res.data) || []);
      },
      error: (err) => {
        this.isLoading = false;
        console.log(err);
      }
    });
  }

  getSubmenu(menuId: string, menus: IMenu[]) {
    return _.sortBy(
      menus.filter((s) => s.parentMenuId == menuId),
      (s) => s.order
    );
  }

  groupMenu(menus: IMenu[]) {
    let menuItems: IMenu[] = menus.filter(
      (m) => !m.isSubMenu && m.parentMenuId == "0"
    );
    for (const menu of menuItems) {
      menu["submenu"] = this.getSubmenu(menu.id, menus);
    }
    return _.sortBy(menuItems, (m) => m.order);
  }

  openNewTabSafari(url) {  
    var a = document.createElement("a");    
    a.href = url;    
    a.setAttribute('target', '_blank');    
    var event = new MouseEvent("click", {
      bubbles: true,
      cancelable: false,
      view: window
    });    
    a.dispatchEvent(event);
  }
  
  getCountMessage() {
    this.digitalMailboxService.getCountMessage()
      .subscribe({
        next: (v) => {
          if (v.code == AppConstant.HTTP_STATUS_CODE_SUCCESS) {
            this.countInboxUnread = v.data[0].countMessage;
            this.countDrafts = v.data[2].countMessage;
            this.value = 0;
            for (let info of v.data) {
              this.value += info.size;
            } 
            if(this.storageUsageInfo){ 
              this.storageUsageInfo.usageInBytes += this.value; 
              this.storageSize = this.storageUsageInfo.usageInBytes;
            }else{
              this.storageSize = this.value
            }
        
            this.calculateStorageUsage();
            this.storageLoading = false;
          }
        },
        error: (e) => {
          this.storageSize += 0;
          this.storageLoading = false;
          this.alertService.error(e.message)
        }
      })
  }

  switchStorageBar(){
    this.storageDocument = !this.storageDocument;
  }
  
}

@Pipe({
  name: 'limitTo'
})
export class TruncatePipe{
  transform(value: string, args: string) : string { 
    if(!value) return value
    let limit = args ? parseInt(args, 10) : 10;
    let trail = '...';
    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
}